import { createFileRoute } from '@tanstack/react-router'

import DashboardPage from '@/components/pages/guest/containers/DashboardPage'

export const Route = createFileRoute('/_guest/guest/')({
  component: DashboardPage
})
